/*
  Info page text tidy-up (sections/magnum-page-content.liquid).

  The page text is typed in the Shopify admin, so this works on whatever is
  there rather than needing every page rewritten:
  - blank paragraphs (just a space or <br>) are removed - they double the gaps
  - an illustration sitting above a heading is put beside it instead
  - a label at the start of a line, before a colon, is made bold
  - email addresses, phone numbers and web addresses become links
  - emails, phone numbers and postal addresses go on their own line with a
    small Magnum illustration in front
  - lines separated by a blank line (<br><br>) become paragraphs of their own,
    so every gap on the page is the same size
  - delivery options - "Standard Delivery: £4.95", "Europe (EU): From £23.99"
    and the like - each get their own line with a Magnum illustration
*/
(function () {
  var root = document.currentScript && document.currentScript.previousElementSibling;
  if (!root || !root.matches('[data-mp-content]')) return;

  var icons = {
    email: root.getAttribute('data-icon-email'),
    phone: root.getAttribute('data-icon-phone'),
    address: root.getAttribute('data-icon-address'),
    van: root.getAttribute('data-icon-van'),
    clock: root.getAttribute('data-icon-clock'),
    calendar: root.getAttribute('data-icon-calendar'),
    basket: root.getAttribute('data-icon-basket'),
    globe: root.getAttribute('data-icon-globe'),
  };

  var POSTCODE = '[A-Z]{1,2}\\d[A-Z\\d]?\\s?\\d[A-Z]{2}';
  var PATTERN = new RegExp(
    [
      '([\\w.+-]+@[\\w-]+(?:\\.[\\w-]+)+)', // 1 email
      '((?:\\+44\\s?\\(0\\)\\s?|\\b0)\\d{3,4}\\s?\\d{3}\\s?\\d{3,4}\\b)', // 2 phone
      '(https?:\\/\\/[^\\s<]+[^\\s<.,;:)])', // 3 web address
      '((?:\\bUnit\\s+\\w+\\s+|\\b\\d{1,4}[A-Za-z]?\\s+)[A-Z][A-Za-z\'’ ]+(?:,\\s*[A-Z][A-Za-z\'’ ]+)*,\\s*' + POSTCODE + '\\b)', // 4 address
    ].join('|'),
    'g'
  );

  function isBlank(el) {
    return !el.querySelector('img, iframe, video, a, input') && el.textContent.replace(/[\s ​]/g, '') === '';
  }

  function iconImg(type) {
    var img = document.createElement('img');
    img.className = 'mp-contact__icon';
    img.src = icons[type];
    img.alt = '';
    img.width = 32;
    img.height = 32;
    return img;
  }

  function contactLine(type, child) {
    var line = document.createElement('span');
    line.className = 'mp-contact mp-contact--' + type;
    line.appendChild(iconImg(type));
    line.appendChild(child);
    return line;
  }

  function link(href, text) {
    var a = document.createElement('a');
    a.href = href;
    a.textContent = text;
    return a;
  }

  function telHref(number) {
    var digits = number.replace(/\(0\)/, '').replace(/[^\d+]/g, '');
    return 'tel:' + digits;
  }

  // A line of its own needs no <br>, stray full stop or space either side.
  function tidyAround(node) {
    ['previousSibling', 'nextSibling'].forEach(function (dir) {
      var removedBreaks = 0;
      var sib = node[dir];
      while (sib) {
        var next = sib[dir];
        if (sib.nodeType === 3) {
          var text = dir === 'nextSibling' ? sib.nodeValue.replace(/^[\s ]*[.,;:]?[\s ]*/, '') : sib.nodeValue.replace(/[\s ]*,?[\s ]*$/, '');
          sib.nodeValue = text;
          if (text !== '') break;
        } else if (sib.nodeName === 'BR' && removedBreaks < 2) {
          sib.remove();
          removedBreaks++;
        } else if (sib.nodeName === 'META') {
          // pasted-in junk from another page
        } else if (dir === 'nextSibling' && sib.nodeType === 1 && /^\s*[.,;:]\s*$/.test(sib.textContent)) {
          sib.remove();
        } else {
          break;
        }
        sib = next;
      }
    });
  }

  // 0. A blank line inside a paragraph (<br><br>) is really a new paragraph.
  //    Splitting there gives every gap the paragraph spacing, instead of some
  //    gaps being a double line and others a paragraph margin.
  root.querySelectorAll('p').forEach(function (p) {
    var nodes = Array.prototype.slice.call(p.childNodes);
    var current = p;
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (node.nodeName !== 'BR') {
        if (current !== p) current.appendChild(node);
        continue;
      }
      // Look past whitespace for a second <br>.
      var j = i + 1;
      while (j < nodes.length && nodes[j].nodeType === 3 && nodes[j].nodeValue.trim() === '') j++;
      if (j < nodes.length && nodes[j].nodeName === 'BR') {
        var next = document.createElement('p');
        (current === p ? p : current).after(next);
        for (var k = i; k <= j; k++) nodes[k].remove();
        current = next;
        i = j;
      } else if (current !== p) {
        current.appendChild(node);
      }
    }
  });

  // 1. Blank paragraphs.
  root.querySelectorAll('p').forEach(function (p) {
    if (isBlank(p)) return p.remove();
    // and a <br> at the very start or end of a paragraph adds an empty line
    ['firstChild', 'lastChild'].forEach(function (end) {
      var node = p[end];
      while (node && (node.nodeName === 'BR' || (node.nodeType === 3 && node.nodeValue.trim() === ''))) {
        var next = end === 'firstChild' ? node.nextSibling : node.previousSibling;
        node.remove();
        node = next;
      }
    });
  });

  // 2. Illustration boxes above headings go beside the heading.
  root.querySelectorAll('div.information-img-box').forEach(function (box) {
    var img = box.querySelector('img');
    var heading = box.nextElementSibling;
    if (!img || !heading || !/^H[2-4]$/.test(heading.nodeName)) return;
    var row = document.createElement('div');
    row.className = 'mp-heading';
    img.className = 'mp-heading__icon';
    img.alt = '';
    box.replaceWith(row);
    row.appendChild(img);
    row.appendChild(heading);
    heading.classList.remove('information-img-box');
  });

  // 2b. A short label that starts a line and ends in a colon is made bold,
  //     e.g. "Standard Delivery: For smaller items..." or "Europe (EU): From".
  var LABEL = /^([\s ]*)([^:.!?\n]{2,60}):(?=[\s ]|$)/;
  root.querySelectorAll('p, li').forEach(function (block) {
    var lineStart = true;
    Array.prototype.slice.call(block.childNodes).forEach(function (node) {
      if (node.nodeName === 'BR') {
        lineStart = true;
        return;
      }
      if (node.nodeType === 3 && node.nodeValue.trim() === '') return;
      if (lineStart && node.nodeType === 3) {
        var match = node.nodeValue.match(LABEL);
        if (match) {
          var label = document.createElement('strong');
          label.className = 'mp-label';
          label.textContent = match[2] + ':';
          node.nodeValue = node.nodeValue.slice(match[0].length);
          block.insertBefore(document.createTextNode(match[1]), node);
          block.insertBefore(label, node);
        }
      }
      lineStart = false;
    });
  });

  // 2c. Delivery options. A short paragraph that starts with the name of a
  //     delivery service and gives a price gets the matching illustration.
  //     Long paragraphs that merely begin with the same words - the notes
  //     explaining each service further down - are left as they are.
  var OPTIONS = [
    [/^standard delivery/i, 'van'],
    [/^next (working )?day/i, 'clock'],
    [/^guaranteed saturday/i, 'calendar'],
    [/^(local )?pick ?up|^click ?(&|and) ?collect/i, 'basket'],
    [/^europe|^rest of the world|^international|^worldwide/i, 'globe'],
  ];
  root.querySelectorAll('p').forEach(function (p) {
    if (p.classList.contains('mp-contact')) return;
    var text = p.textContent.replace(/[\s ]+/g, ' ').trim();
    if (text.length > 110 || !/£|free/i.test(text)) return;
    for (var n = 0; n < OPTIONS.length; n++) {
      if (!OPTIONS[n][0].test(text) || !icons[OPTIONS[n][1]]) continue;
      var body = document.createElement('span');
      body.className = 'mp-option__text';
      while (p.firstChild) body.appendChild(p.firstChild);
      var img = iconImg(OPTIONS[n][1]);
      img.className = 'mp-option__icon';
      p.appendChild(img);
      p.appendChild(body);
      p.classList.add('mp-option');
      break;
    }
  });

  // 3. A whole paragraph that is an address (lines split with <br>, ending in
  //    a postcode) becomes one address block.
  var postcodeAtEnd = new RegExp(POSTCODE + '\\s*$');
  root.querySelectorAll('p').forEach(function (p) {
    var text = p.textContent.trim();
    if (!p.querySelector('br') || text.length > 250 || !postcodeAtEnd.test(text)) return;
    var body = document.createElement('span');
    while (p.firstChild) body.appendChild(p.firstChild);
    p.appendChild(iconImg('address'));
    p.appendChild(body);
    p.classList.add('mp-contact', 'mp-contact--address', 'mp-contact--block');
  });

  // 4. Links that are already there.
  root.querySelectorAll('a[href^="mailto:"], a[href^="tel:"]').forEach(function (a) {
    var type = a.getAttribute('href').indexOf('mailto:') === 0 ? 'email' : 'phone';
    var target = a.parentNode.nodeName === 'SPAN' && a.parentNode.childNodes.length === 1 ? a.parentNode : a;
    var line = contactLine(type, document.createElement('span'));
    target.replaceWith(line);
    line.replaceChild(a, line.lastChild);
    a.removeAttribute('target');
    tidyAround(line);
  });

  // 5. Plain text emails, phone numbers, web addresses and postal addresses.
  var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
    acceptNode: function (node) {
      return node.parentNode.closest('a, script, style, .mp-contact') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
    },
  });
  var textNodes = [];
  while (walker.nextNode()) textNodes.push(walker.currentNode);

  textNodes.forEach(function (node) {
    var text = node.nodeValue;
    PATTERN.lastIndex = 0;
    if (!PATTERN.test(text)) return;
    PATTERN.lastIndex = 0;

    var frag = document.createDocumentFragment();
    var lines = [];
    var last = 0;
    var match;
    while ((match = PATTERN.exec(text))) {
      if (match.index > last) frag.appendChild(document.createTextNode(text.slice(last, match.index)));
      var el;
      if (match[1]) {
        el = contactLine('email', link('mailto:' + match[1], match[1]));
      } else if (match[2]) {
        el = contactLine('phone', link(telHref(match[2]), match[2].trim()));
      } else if (match[3]) {
        el = link(match[3], match[3].replace(/^https?:\/\/(www\.)?/, ''));
        el.target = '_blank';
        el.rel = 'noopener';
      } else {
        var span = document.createElement('span');
        span.textContent = match[4];
        el = contactLine('address', span);
      }
      frag.appendChild(el);
      if (el.classList.contains('mp-contact')) lines.push(el);
      last = match.index + match[0].length;
    }
    if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
    node.replaceWith(frag);
    lines.forEach(tidyAround);
  });
})();
